export const formInitialValues = (advancedSettings) => {
  return {
    hideProductRedirect: advancedSettings.hideProductSettings.redirect,
    hideProductCustomRedirectURL: advancedSettings.hideProductSettings.customRedirectUrl,
    hideProductIsActiveTags: advancedSettings.hideProductSettings.isActiveTags,
    hideProductSpecificShopifyPage: advancedSettings.hideProductSettings.specificShopifyPage,
    hideProductSpecificShopifyBlog: advancedSettings.hideProductSettings.specificShopifyBlog,
    hideProductSpecificProductPage: advancedSettings.hideProductSettings.specificProductPage,
    hideProductSelectedTags: advancedSettings.hideProductSettings.selectedTags,
    downProductIsActiveTags: advancedSettings.downProductSettings.isActiveTags,
    downProductSelectedTags: advancedSettings.downProductSettings.selectedTags,
    backProductIsActiveVisibleTags: advancedSettings.backProductSettings.isActiveVisibleTags,
    backProductIsActiveExcludeTags: advancedSettings.backProductSettings.isActiveExcludeTags,
    backProductVisibleSelectedTags: advancedSettings.backProductSettings.visibleSelectedTags,
    backProductExcludeSelectedTags: advancedSettings.backProductSettings.excludeSelectedTags,
    locationSettings: {
      monitorAllLocations: advancedSettings.locationSettings?.monitorAllLocations ?? true,
      selectedLocationIds: advancedSettings.locationSettings?.selectedLocationIds ?? [],
      selectedLocationNames: advancedSettings.locationSettings?.selectedLocationNames ?? [],
    },
  }

};